<template>
  <div>
    <div class="sac__font-18 med">
      Service
    </div>
    <div class="tuneup-card margin-top-16">
      <div class="grid-row jc-c">
        <img
          src="@shared/assets/img/performance-summary/tech-truck.svg"
          alt="tech"
          class="tech-img"
        />
      </div>
      <div class="grid-column ai-c jc-c gap-16 margin-top-16">
        <div class="sac__font-16 med">
          Last Service Date:
        </div>
        <div class="sac__font-16 med">
          {{ lastServiceDate }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'TuneupDetail',
  computed: {
    ...mapState({
      selectedUnit: (state) => state.customerDetail.selectedUnit,
    }),
    lastServiceDate() {
      const {
        lastServiceDate,
      } = this.selectedUnit;
      if (!lastServiceDate) {
        return '--';
      }
      return moment(lastServiceDate).format('MMM DD, YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
.tuneup-card {
  background-color: $N5;
  border-radius: 8px;
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: 15rem;
  .tech-img {
    height: 94px;
    width: 161px;
  }
}
</style>
